module.exports = __webpack_public_path__ + "img/skridsko_par.54734f01.jpg";